// 작품 상세 — 소개와 회차 목록. 첫 회차부터 읽기 버튼, 내 작품이면 회차 쓰기
import { Link, useNavigate, useParams } from 'react-router';

import { usePluginMessages } from '../../../composition/plugin-runtime';
import { useRemoveWork, useWork, type SerialApi } from '../composition/use-serial';
import { episodeLabel } from '../domain/serial';
import { AiBadge, ConfirmRemove, ErrorText, Loading } from './parts';
import { WhifButton } from './whif/shared/ui/whif-button';

export function workPage(api: SerialApi) {
  return function SerialWorkPage() {
    const t = usePluginMessages('serial');
    const id = useParams().id ?? '';
    const work = useWork(api, id);
    const navigate = useNavigate();
    const remove = useRemoveWork(api);
    if (work.isPending) return <Loading />;
    if (!work.data) return <ErrorText error={work.error} />;
    const { work: w, episodes } = work.data;
    const first = episodes[0];
    return (
      <article className="flex flex-col gap-6 pt-6">
        <header className="flex flex-col gap-3">
          <AiBadge usage={w.aiUsage} />
          <h1 className="text-title-lg">{w.title}</h1>
          {w.synopsis ? <p className="whitespace-pre-wrap text-sm text-text-neutral-subtle">{w.synopsis}</p> : null}
          <div className="flex gap-2 pt-1">
            {first ? (
              <WhifButton asChild size="lg">
                <Link to={`/episodes/${first.id}`}>{t('work.readFirst')}</Link>
              </WhifButton>
            ) : null}
            {w.mine ? (
              <WhifButton asChild size="lg" variant="gray">
                <Link to={`/works/${w.id}/write`}>{t('work.writeEpisode')}</Link>
              </WhifButton>
            ) : null}
          </div>
          {w.mine ? (
            <div className="flex flex-col gap-2">
              <ConfirmRemove
                label={t('remove.work')}
                question={t('remove.workQuestion')}
                pending={remove.isPending}
                onConfirm={() => remove.mutate(w.id, { onSuccess: () => void navigate('/') })}
              />
              <ErrorText error={remove.error} />
            </div>
          ) : null}
        </header>
        <section className="flex flex-col">
          <h2 className="pb-2 text-label-sm-sb text-text-neutral-weak">
            {t('feed.episodes')} {episodes.length}
          </h2>
          {episodes.length === 0 ? <p className="py-8 text-center text-sm text-text-neutral-subtle">{t('work.noEpisodes')}</p> : null}
          <ol className="flex flex-col divide-y divide-serial-line border-t border-serial-line">
            {episodes.map(ep => (
              <li key={ep.id}>
                <Link to={`/episodes/${ep.id}`} className="flex items-center justify-between gap-3 py-3 hover:text-text-brand-primary-solid">
                  <span className="truncate">{episodeLabel(ep.no, ep.title)}</span>
                  <span className="shrink-0 text-label-xs-m text-text-neutral-weak">{ep.publishedAt.slice(0, 10)}</span>
                </Link>
              </li>
            ))}
          </ol>
        </section>
      </article>
    );
  };
}
